import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Offcanvas } from "react-bootstrap";

import NotificationItem from "./NotificationItem";
import ThemeSpinner from "../ThemeSpinner";

// query
import { getNotification } from "src/Query/Dashboard/dashboard.query";

import { iconNotification } from "src/assets/images";
import { queryKey } from "src/constants/generics";
import queryClient from "src/queryClient";
import { Strings } from "src/resources";
import IconButton from "../IconButton";
import "./notification.scss";

const NOTIFICATION_INITIAL_FILTER = {
  limit: 12
};

const Notification = () => {
  const [show, setShow] = useState(false);
  const [notificationFilter, setNotificationFilter] = useState(NOTIFICATION_INITIAL_FILTER);
  const [notificationData, setNotificationData] = useState([]);

  const handleClose = () => {
    setShow(false);
    setNotificationData([]);
    setNotificationFilter(NOTIFICATION_INITIAL_FILTER);
  };
  const handleShow = () => {
    setShow(true);
    queryClient.invalidateQueries([queryKey.getNotification]);
  };

  // get Itinerary
  const { data: notificationResData, isFetching: isNotificationFetching } = useQuery({
    queryKey: [queryKey.getNotification, notificationFilter],
    queryFn: () => getNotification(notificationFilter),
    select: (data) => data?.data,
    onSuccess: (data) => {
      if (show) {
        setNotificationData((prev) => [...(prev?.length ? prev : []), ...(data?.notifications?.length ? data.notifications : [])]);
      }
    }
  });



  function handleFetchOnScroll(event) {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - scrollTop === clientHeight && !isNotificationFetching && notificationResData?.count > notificationData?.length) {
      setNotificationFilter((prev) => ({
        ...prev,
        startAfterDocId: notificationResData?.nextStartAfterDocId
      }));
    }
  }

  return (
    <div className="notification">
      <div className="position-relative">
        <IconButton onClick={handleShow} icon={iconNotification} />
        <span className="bg-primary fs-8 p-1 position-absolute rounded-5 text-white text-center start-50 notification-count">
          {notificationResData?.count > 99 ? "99+" : notificationResData?.count || 0}
        </span>
      </div>

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton className="notification-offcanvas">
          <Offcanvas.Title>{`${Strings.notification}`}</Offcanvas.Title>
          <p
            style={{
              paddingLeft: "10px"
            }}
            className="mt-1  text-neutral-70"
          >{`${notificationResData?.count || 0}- unread notifications`}</p>
        </Offcanvas.Header>
        <Offcanvas.Body className="position-relative overflow-hidden">
          {isNotificationFetching && (
            <div className="bg-light bg-opacity-50 d-flex h-100 position-absolute w-100 z-1">
              <ThemeSpinner />
            </div>
          )}
          <div className="d-flex flex-column gap-2 overflow-auto h-100" onScroll={handleFetchOnScroll}>
            {notificationData?.map((item, index) => (
              <NotificationItem item={item} key={index} handleClose={handleClose} />
            ))}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Notification;
